const identity = (response, props) => response instanceof Error ? {
  error: response,
  props
} : {
  data: response,
  props
};

export default function createAction(type, payloadCreator = identity, metaCreator) {
  const finalPayloadCreator = payloadCreator === identity ? identity : (...args) => {
    const [head, ...rest] = args;
    return head instanceof Error ? head : payloadCreator(head, ...rest);
  };
  const typeString = type.toString();

  const actionCreator = (...args) => {
    const payload = finalPayloadCreator(...args);
    const action = {
      type
    };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (metaCreator) {
      action.meta = metaCreator(...args);
    }

    return action;
  };

  actionCreator.toString = () => typeString;

  return actionCreator;
}